import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Tiny floating chip that shows the number of visitors currently online.
 * Polls /api/live-visitors every 25s. Hidden when count <= 0 to avoid showing
 * "0 online" on cold start.
 */
export default function LiveVisitorsChip() {
    const [count, setCount] = useState(null);

    useEffect(() => {
        let mounted = true;
        const fetchOnce = async () => {
            try {
                const { data } = await api.get("/live-visitors");
                if (mounted) setCount(data?.count ?? 0);
            } catch {
                /* ignore */
            }
        };
        fetchOnce();
        const id = setInterval(fetchOnce, 25_000);
        return () => {
            mounted = false;
            clearInterval(id);
        };
    }, []);

    if (count === null || count <= 0) return null;

    return (
        <div
            data-testid="live-visitors-chip"
            className="fixed bottom-4 right-4 z-40 inline-flex items-center gap-2 px-3 py-2 rounded-full bg-[color:var(--bg-base)]/90 backdrop-blur border border-white/10 text-xs text-white shadow-lg select-none pointer-events-none"
            aria-live="polite"
        >
            <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#22c55e] opacity-60" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#22c55e]" />
            </span>
            <span>
                <strong>{count}</strong>{" "}
                <span className="text-[color:var(--text-secondary)]">
                    {count === 1 ? "osoba" : "osób"} online
                </span>
            </span>
        </div>
    );
}
